import { useCallback } from 'react';

import {
	ExperienceName,
	useAIMateExperienceTracker,
} from '@atlassian/conversation-assistant-instrumentation';
import {
	type AgentKnowledgeConfiguration,
	type AssistanceServiceConfig,
	useAssistanceService,
	useQuery,
} from '@atlassian/conversation-assistant-service';

export const useKnowledgeConnectors = (params?: {
	config?: AssistanceServiceConfig;
	enabled?: boolean;
}) => {
	const service = useAssistanceService(params?.config);
	const experienceTracker = useAIMateExperienceTracker();

	const connectorsQuery = useQuery({
		queryKey: ['getKnowledgeConnectors'],
		queryFn: async () => {
			experienceTracker.start({
				id: ExperienceName.FETCH_CONNECTED_KNOWLEDGE_SOURCES,
				name: ExperienceName.FETCH_CONNECTED_KNOWLEDGE_SOURCES,
			});

			return service.getAgentKnowledgeConfiguration();
		},
		onSuccess: () => {
			experienceTracker.succeed({
				name: ExperienceName.FETCH_CONNECTED_KNOWLEDGE_SOURCES,
			});
		},
		onError: (error) => {
			experienceTracker.fail({
				name: ExperienceName.FETCH_CONNECTED_KNOWLEDGE_SOURCES,
				error,
			});
		},
		enabled: params?.enabled ?? true,
	});

	const isConnectorEnabled = useCallback(
		(type: AgentKnowledgeConfiguration['source']): boolean => {
			return (
				connectorsQuery.data?.knowledgeSources?.some((value) => value.source === type) ?? false
			);
		},
		[connectorsQuery.data],
	);

	return {
		isConnectorEnabled,
	};
};
